export default "__VITE_ASSET__DelIIB3u__"